"use strict";

import 'core-js/features/string/includes';
import 'core-js/features/array';
import 'core-js/features/object/assign';
import 'core-js/features/object/entries';

import 'bootstrap/js/src/dropdown.js';
import 'bootstrap/js/src/button.js';
import 'bootstrap/js/src/alert.js';
import 'bootstrap/js/src/tooltip.js';
import 'bootstrap/js/src/collapse.js';

import 'bootstrap-multiselect/dist/js/bootstrap-multiselect.js';
//import 'bootstrap-daterangepicker/daterangepicker.js';
import './daterangepicker.js'
import 'bootstrap-select/dist/js/bootstrap-select.js';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.de.js';

window.Buffer = window.Buffer || require('buffer').Buffer;